import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, query, where, getDocs, orderBy, addDoc } from 'firebase/firestore';
import { db, auth } from '../firebase';
import Header from '../components/Header';
import './ControlaEnojoScreen.css';
import { logEvent } from '../analytics';
import { FaLock } from 'react-icons/fa';

const ControlaEnojoScreen = () => {
  const [ejercicios, setEjercicios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showToast, setShowToast] = useState(false);
  const [showFeedbackButton, setShowFeedbackButton] = useState(true);

  useEffect(() => {
    const feedbackSubmitted = localStorage.getItem('feedback_anger_submitted');
    if (feedbackSubmitted) {
      setShowFeedbackButton(false);
    }
  }, []);

  const handleFeedback = async () => {
    try {
      const userId = auth.currentUser?.uid || localStorage.getItem('user_id') || 'anonymous';

      await addDoc(collection(db, 'herramientas_lead'), {
        user_id: userId,
        clicked_at: new Date()
      });

      setShowToast(true);
      setShowFeedbackButton(false);
      localStorage.setItem('feedback_anger_submitted', 'true');
      setTimeout(() => setShowToast(false), 3000);
    } catch (error) {
      console.error("Error saving feedback:", error);
    }
  };

  useEffect(() => {
    const fetchEjercicios = async () => {
      try {
        const q = query(
          collection(db, 'content'),
          where('type', '==', 'anger_management'),
          orderBy('level', 'asc')
        );
        const querySnapshot = await getDocs(q);
        const ejerciciosData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setEjercicios(ejerciciosData);
      } catch (error) {
        console.error("Error fetching anger management exercises: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEjercicios();
  }, []);

  return (
    <div className="controla-enojo-screen">
      <Header backTo="/" />
      <div className='home-container'>
        {/* Título */}
        <div className="welcome-section">
          <h3 className="welcome-text">Domina tus reacciones</h3>
        </div>

        {loading ? (
          <div className="loading_controla_enoj">Cargando...</div>
        ) : (
          <div className="complementary-section">
            <div className="complementary-title">Ejercicios disponibles</div>
            {ejercicios.map(ejercicio => (
              <Link
                to={`/ejercicio-enojo/${ejercicio.id}`}
                key={ejercicio.id}
                className="complementary-card"
                style={{ textDecoration: 'none' }}
                onClick={() => logEvent('AngerManagement', 'Select', ejercicio.name)}
              >
                <div className="complementary-card-text">
                  <p className="complementary-card-category text-sm">Domina tus reacciones</p>
                  <p className="complementary-card-title text-middle">{ejercicio.name}</p>
                  <p className="complementary-card-sessions text-sm">Nivel: {ejercicio.level}</p>
                </div>
                {/*                 <div
                  className="complementary-card-img"
                  style={{ backgroundImage: `url(${ejercicio.image_url})` }}
                ></div> */}
              </Link>
            ))}

            {/* Locked Card */}
            <div
              className="complementary-card"
              style={{
                textDecoration: 'none',
                opacity: 0.6,
                cursor: 'default',
                position: 'relative',
                overflow: 'hidden',
                border: '1px solid rgba(255,255,255,0.1)'
              }}
            >
              <div className="complementary-card-text" style={{ width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                  <FaLock size={16} color="#93acc8" />
                  <p className="complementary-card-category text-sm" style={{ margin: 0 }}>Próximamente disponible</p>
                </div>
                <p className="complementary-card-title text-middle">Diario de emociones</p>
                <p className="complementary-card-sessions text-sm">Nivel: 3</p>


              </div>
            </div>
            {showFeedbackButton && (
              <button
                onClick={handleFeedback}
                style={{
                  marginTop: '16px',
                  padding: '12px 20px',
                  backgroundColor: '#4b8fa2',
                  color: 'white',
                  border: 'none',
                  borderRadius: '25px',
                  fontSize: '16px',
                  cursor: 'pointer',
                  width: '100%',
                  fontWeight: '400',
                  transition: 'background 0.2s'
                }}
              >
                Quiero más ejercicios como estos
              </button>
            )}
          </div>
        )}

        {/* Toast Notification */}
        {showToast && (
          <div style={{
            position: 'fixed',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#333',
            color: 'white',
            padding: '16px 32px',
            borderRadius: '12px',
            boxShadow: '0 8px 16px rgba(0,0,0,0.3)',
            zIndex: 1000,
            fontSize: '16px',
            fontWeight: '500',
            textAlign: 'center',
            animation: 'fadeIn 0.3s ease-in-out'
          }}>
            Gracias, usaremos tu feedback para crear más herramientas.
          </div>
        )}
      </div>
    </div>
  );
};

export default ControlaEnojoScreen; 